import React from 'react';

interface IconShareProps {
    iconClasses?: string;
}

const IconShare: React.FC<IconShareProps> = ({ iconClasses }) => {
    return (
        <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-share ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <path
                d="M11.375 2.70825C11.375 3.60571 10.6475 4.33325 9.75 4.33325C8.85254 4.33325 8.125 3.60571 8.125 2.70825C8.125 1.81079 8.85254 1.08325 9.75 1.08325C10.6475 1.08325 11.375 1.81079 11.375 2.70825Z"
                strokeWidth="1.08333"
                stroke="currentColor"
            />
            <path
                d="M4.875 6.5C4.875 7.39746 4.14746 8.125 3.25 8.125C2.35254 8.125 1.625 7.39746 1.625 6.5C1.625 5.60254 2.35254 4.875 3.25 4.875C4.14746 4.875 4.875 5.60254 4.875 6.5Z"
                strokeWidth="1.08333"
                stroke="currentColor"
            />
            <path
                d="M11.375 10.2917C11.375 11.1892 10.6475 11.9167 9.75 11.9167C8.85254 11.9167 8.125 11.1892 8.125 10.2917C8.125 9.39429 8.85254 8.66675 9.75 8.66675C10.6475 8.66675 11.375 9.39429 11.375 10.2917Z"
                strokeWidth="1.08333"
                stroke="currentColor"
            />
            <path d="M4.65234 7.31787L8.35193 9.4737" strokeWidth="1.08333" stroke="currentColor" />
            <path d="M8.34651 3.52637L4.65234 5.6822" strokeWidth="1.08333" stroke="currentColor" />
        </svg>
    );
};

export default IconShare;
